// Single source of truth for the homepage hero backdrop
export const HOME_HERO_GRADIENT_DESKTOP = `
    radial-gradient(
        ellipse 120% 100% at top center,
        rgba(217, 233, 255, 0.8) 0%,
        rgba(217, 233, 255, 0.3) 35%,
        rgba(217, 233, 255, 0.1) 55%,
        rgba(255, 255, 255, 0) 70%,
        rgb(255, 255, 255) 100%
    )
`

export const HOME_HERO_GRADIENT_MOBILE = `
    radial-gradient(
        circle at top center,
        rgba(217, 233, 255, 0.8) 0%,
        rgba(217, 233, 255, 0.3) 40%,
        rgba(217, 233, 255, 0.1) 60%,
        rgb(255, 255, 255) 100%
    )
`
